import { v4 as uuidV4 } from 'uuid';
import React, { useImperativeHandle, useMemo } from 'react';
import LayoutContextWrapper from '../../contexts/layout';
import { ModalContext } from '../../contexts/modal';
import FooterFactory from '../../factories/footer-factory';
import LayoutFactory from '../../factories/layout-factory';
import { useModal } from '../../hooks/modal/useModal';
import Loader from '../loader';

export interface IModalRefs {
    show: (layoutLink: string, rowIdParam?: string | number | null, idOwner?: string | number | null) => void;
}

interface IModalProps {
    idOwner?: string | number;
    onHide?: () => void;
}

const ModalComponent = React.forwardRef(({ idOwner, onHide }: IModalProps, ref) => {
    const hook = useModal({ onHide });

    useImperativeHandle(ref, () => ({
        show: hook.show,
    }));

    const classes = ['modal', 'fade'];

    if (hook.visible) {
        classes.push('show');
    }

    return (
        <ModalContext.Provider value={hook.modalContextValue}>
            <div className={classes.join(' ')} role="dialog">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <Loader loading={hook.layoutLoading} title="Загрузка макета" height={250} />
                        {!hook.layoutLoading && (
                            <>
                                <div className="modal-header">
                                    <h5 className="modal-title" dangerouslySetInnerHTML={{ __html: hook.layout?.title || '' }} />
                                    <button type="button" className="btn btn-outline p-0" onClick={hook.hide}>
                                        <i className="fa fa-close" />
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <LayoutFactory layout={hook.layout?.layout || []} idOwner={idOwner} rowId={hook.rowId} />
                                </div>
                                {hook.layout && Array.isArray(hook.layout?.footer) && (
                                    <div className="modal-footer">
                                        <FooterFactory layout={hook.layout.footer} idOwner={idOwner} rowId={hook.rowId} />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ModalContext.Provider>
    );
});

const Modal = React.forwardRef((props: IModalProps, ref) => {
    const layoutId = useMemo(() => uuidV4(), []);

    return (
        <LayoutContextWrapper layoutId={layoutId}>
            <ModalComponent ref={ref} {...props} />
        </LayoutContextWrapper>
    );
});

ModalComponent.defaultProps = {
    idOwner: undefined,
    onHide: undefined,
};

Modal.defaultProps = {
    idOwner: undefined,
    onHide: undefined,
};

export default Modal;
